import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {Dialog, DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {ToastService} from "shared/utilities/services/ToastService";
import {SortSnippets} from "shared/utilities/Snipets/SortSnippets";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";
import Axios from "axios";
import {FieldSummaryItemOptions, FieldSummaryOptions} from "../Controls/ControlsList/FieldSummary.Options";
import {PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {TemplateManagerDialog} from "PageBuilder/Dialogs/TemplateManager/TemplateManagerDialog";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {previewType} from "PageBuilder/pagebuilder/services/PageService";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";




library.add(faSpinner);
library.add(faSearch);
export class FormPicker extends DynamicDialog<any,FormPickerState> {
    static defaultProps: Partial<FormPickerProps> = {};

    constructor(props: FormPickerProps) {
        super(props);
        this.state = {
            IsOpen:true,
            SelectedForm:rednaoVar.FormList.length>0?rednaoVar.FormList[0].Id:'',
            SelectedTemplateId:'summary',
            IsBusy:false,
            IsBusySelect:false
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Please select a form and template',
            EnableCancel:false,
            EnableApply:true,
            Styles:{width:'80%',maxWidth:1200},
            ApplyTitle:'Select',
            IsBusy:this.state.IsBusySelect,
            OnApply:async ()=>{
                let form=rednaoVar.FormList.find(x=>x.Id==this.state.SelectedForm);
                if(form==null)
                    ToastService.SendErrorMessage('Please select a form first');
                else {
                    let fields=(form.Fields as FieldDTO[]);
                    fields=SortSnippets.SortByProperty(fields,"Label");
                    let templateData=null;
                    if(this.state.SelectedTemplateId!='blank')
                    {


                        let templateItem=rednaoVar.TemplateList.find(x=>x.Id==this.state.SelectedTemplateId);
                        if(templateItem.IsPR&&rednaoVar.IsPr=='')
                        {
                            Dialog.Show(<LicenseIsRequired Message={'This template is only available in the full version'}/>);
                            return;
                        }

                        this.setState({IsBusy:true,IsBusySelect:true});
                        let result=await WpAjaxPost.Post('generate_local_template',{Id:templateItem.Id,IsPR:templateItem.IsPR});
                        this.setState({IsBusy:false,IsBusySelect:false});
                        if(result!=null)
                        {
                            templateData=new PDFDocumentOptions().Merge(result.data);
                            this.TransportTemplate(templateData,fields,form.Id);
                            if(templateItem.Id!='summary') {
                                templateData = await Dialog.Show(<TemplateManagerDialog DocumentOptions={templateData}
                                                                                        FormIdAlreadyDefined={true}/>);
                                if (templateData == null)
                                    return;
                            }
                            this.SendResult({
                                Form:{Id: form.Id, Fields:fields,Notifications:form.Notifications},
                                TemplateData:templateData
                            });
                        }
                        return;
                    }

                    this.SendResult({
                        Form:{Id: form.Id, Fields:fields,Notifications: form.Notifications},
                        TemplateData:templateData
                    });
                }
            }

        };
    }

    SubRenderer(): React.ReactNode {
        return (
            <div style={{position:"relative"}}>
                <div>
                    <SearchableSelect Label={'Form'} Value={this.state.SelectedForm} onChange={e=>this.setState({SelectedForm:e as any})}>
                        {rednaoVar.FormList.map(x=>
                            <option key={x.Id} value={x.Id}>{x.Name}</option>
                        )}
                    </SearchableSelect>
                </div>
                <div>
                    <label>Templates</label>
                    <div style={{display:'flex',flexWrap:'wrap'}}>
                        {rednaoVar.TemplateList.map(form=>
                            <div key={form.Id} style={{position:'relative'}} onClick={e=>this.setState({SelectedTemplateId:form.Id})} className={'templateItem '+(this.state.SelectedTemplateId==form.Id?"selected":'')}>
                                <div style={{position:"relative",width:200,height:280}}>
                                    {form.IsPR ?
                                        <img style={{width: '100%', height: '100%'}} src={`http://pdfbuilder.rednao.com/wp-content/uploads/wpformbuilder/${form.Id}/preview.png`}/>
                                        :<img style={{width: '100%', height: '100%'}} src={`${rednaoVar.URL}templates/${form.Id}/preview.png`}/>
                                    }

                                    {form.IsPR&&
                                        <img style={{position:"absolute",bottom:0,right:0}} src={`${rednaoVar.URL}images/fullOnly.png`}/>
                                    }
                                </div>
                                <label style={{textAlign:"center",display:"block"}}>{form.Title}</label>
                                {form.Id != 'blank' &&
                                <div className={'previewButton'} onClick={e=>this.ExecutePreview(form)} style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    textAlign: 'center',
                                    backgroundColor: 'red',
                                    color: 'white'
                                }}><div><FontAwesomeIcon icon={"search"}/> Preview</div></div>
                                }
                            </div>
                        )}

                    </div>
                </div>
                {
                this.state.IsBusy&&
                <div style={{backgroundColor:"black",width:'100%',height:'100%',opacity:.5,position:'absolute',top:0,left:0,color:"white",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexDirection:'column'}}>
                    <FontAwesomeIcon icon={"spinner"} spin={true}/>
                    <label>Loading template, please wait</label>
                </div>
                    }
            </div>
        )
    }

    private TransportTemplate(templateData: PDFDocumentOptions, fields: FieldDTO[],formId) {
        templateData.FormId=formId;
        for(let page of templateData.Pages)
            for(let field of page.Fields)
            {
                if(field.Type==ControlTypeEnum.Summary)
                {
                    let summaryOptions=field as FieldSummaryOptions;
                    summaryOptions.Fields=[];
                    for(let formField of fields)
                        summaryOptions.Fields.push(new FieldSummaryItemOptions().Merge({Id:formField.Id,Label:formField.Label}));
                }
            }
    }

    private async ExecutePreview(form:{Id:string,Title:string,IsZip:boolean,IsPR:boolean}) {
        if(form.IsPR)
        {
            window.open(`http://pdfbuilder.rednao.com/wp-content/uploads/wpformbuilder/${form.Id}/pdf.pdf`);
            return;
        }


        this.setState({IsBusy:true});
        let result=await WpAjaxPost.Post('generate_local_template',{Id:form.Id,IsPR:form.IsPR});
        if(result==null) {
            this.setState({IsBusy:false});
            return;
        }

        let templateData=new PDFDocumentOptions().Merge(result.data);


        let options=templateData.ToObject();
        let $form=jQuery(`<form style="display: none" enctype="multipart/form-data" method="post" target="_blank" action="${(window as any).ajaxurl}">
                                <input name="action" type="hidden" value="${rednaoVar._prefix}_execute_preview"/>
                                <input name="data" type="hidden"  value="" class="json" />
                                <input name="_nonce" type="hidden"  value="${rednaoVar._nonce}" />
                                <button></button>
                           </form>                           
                        `);


        jQuery('body').append($form);
        $form.find('.json').val(JSON.stringify({PageOptions:options}));
        $form.submit();
        this.setState({IsBusy:false});

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormPickerProps {

}

interface FormPickerState extends DynamicDialogState{
    SelectedForm:string;
    SelectedTemplateId:string;
    IsBusy:boolean;
    IsBusySelect:boolean;
}

//#endregion "My Region"